import { z } from 'zod'
import { PLATFORM_CAPABILITIES } from '../types/module'

export const moduleNavigationItemSchema = z.object({
  label: z.string().min(1),
  path: z.string().min(1),
  icon: z.string().min(1),
  badge: z.union([z.string(), z.number()]).optional(),
})

export const moduleNavigationGroupSchema = z.object({
  label: z.string().min(1),
  items: z.array(moduleNavigationItemSchema).min(1),
})

export const moduleNavigationSchema = z.object({
  label: z.string().min(1),
  icon: z.string().min(1),
  groups: z.array(moduleNavigationGroupSchema).min(1),
})

export const moduleFixtureSchema = z.object({
  file: z.string().min(1),
  doctype: z.string().min(1),
})

export const moduleConfigSchema = z.object({
  name: z.string().min(1).regex(/^[a-z][a-z0-9-]*$/, 'Module name must be lowercase kebab-case'),
  label: z.string().min(1),
  icon: z.string().min(1),
  version: z.string().regex(/^\d+\.\d+\.\d+$/, 'Version must be semver format'),
  dependencies: z.array(z.string()),

  schemas: z.record(z.unknown()),
  routes: z.record(z.unknown()),
  navigation: moduleNavigationSchema,
  permissions: z.record(z.unknown()),
  hooks: z.record(z.unknown()),

  requiredPlatformCapabilities: z.array(z.enum(PLATFORM_CAPABILITIES)).optional(),
  extendSchemas: z.record(z.record(z.string())).optional(),
  fixtures: z.array(moduleFixtureSchema).optional(),
})

export const kubdeeConfigSchema = z.object({
  site: z.object({
    name: z.string().min(1),
    url: z.string().url(),
  }),
  modules: z.record(z.boolean()),
  d1: z.object({ binding: z.string().min(1) }),
  r2: z.object({ binding: z.string().min(1) }),
  kv: z.object({ binding: z.string().min(1) }),
})
